import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { CONTRACT_TYPE } from '~/constants';
import { useTokenStore, useUserInfoStore } from '~/store';

export const usePolicyBottomSheet = () => {
  const [open, setOpen] = useState(false);
  const closedResolverRef = useRef<((value: void) => void) | null>(null);

  const { pathname } = useLocation();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = async () => {
    if (!open) {
      return Promise.resolve();
    }

    setOpen(false);
    return new Promise<void>((resolve) => {
      closedResolverRef.current = resolve;
    });
  };

  useEffect(() => {
    const isTarget = useUserInfoStore.getState().reConsentRequired;
    const accessToken = useTokenStore.getState().accessToken;

    if (!isTarget || !accessToken) {
      return;
    }

    const contractType = useUserInfoStore.getState().contractType;

    const isShortTarget = contractType === CONTRACT_TYPE.SHORT && pathname === '/check-network';
    const isContractTarget = contractType === CONTRACT_TYPE.CONTRACT && pathname === '/start-work';

    const shouldShow = isShortTarget || isContractTarget;

    if (!shouldShow) {
      setOpen(false);
      return;
    }

    setTimeout(() => {
      setOpen(true);
    }, 0);
  }, [pathname]);

  useEffect(() => {
    if (!open && closedResolverRef.current) {
      const resolve = closedResolverRef.current;
      closedResolverRef.current = null;

      resolve();
    }
  }, [open]);

  return { open, handleOpen, handleClose };
};
